import type { Registration } from '../client';

export type StaffMemberLike = {
    id: number;
    email: string;
};

export function buildStaffByEmailMap(
    staffMembers: StaffMemberLike[] | undefined,
): Map<string, StaffMemberLike> {
    return new Map(
        (staffMembers ?? []).map((member) => [member.email.toLowerCase(), member]),
    );
}

export function buildStaffEmailSet(staffMembers: StaffMemberLike[] | undefined): Set<string> {
    return new Set(
        (staffMembers ?? []).map((member) => member.email.toLowerCase()),
    );
}

export type StaffRegistrationLike = {
    email: string;
    paid: string;
};

export function isStaffRegistration(
    registration: StaffRegistrationLike,
    staffEmails: Set<string>,
): boolean {
    return (
        staffEmails.has(registration.email.toLowerCase())
        || registration.paid === 'staff'
    );
}

export function filterRegistrationsByStaffVisibility(
    registrations: Registration[],
    staffEmails: Set<string>,
    showStaffRegistrations: boolean,
): Registration[] {
    if (showStaffRegistrations) {
        return registrations;
    }
    return registrations.filter(
        (registration) => !isStaffRegistration(registration, staffEmails),
    );
}
